import { useState } from "react";

const faqs = [
  { q: "Who provides architectural design services near me?", a: "Archicon Services provides architectural design solutions for residential and commercial projects in Houston and surrounding areas, helping clients bring functional and visually refined spaces to life." },
  { q: "How much does architectural design cost?", a: "Costs vary based on project size, complexity, and scope. Archicon Services provides customized pricing after understanding the project requirements and design goals. Contact us for a free consultation." },
  { q: "How long does architectural design take?", a: "Timelines depend on project complexity. Initial concepts may take a few weeks, while full design and construction documentation can take several weeks to months." },
  { q: "Do you handle both residential and commercial projects?", a: "Yes. Archicon Services has extensive experience in both residential and commercial architectural design across the greater Houston area." },
  { q: "What is included in construction drawings?", a: "Construction drawings include detailed, build-ready plans with dimensions, specifications, and all documentation required for permitting and contractor execution." },
  { q: "Can you help with renovations and additions?", a: "Absolutely. We specialize in reimagining and expanding existing structures with cohesive design that respects the original architecture while elevating the overall space." },
];

export default function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return (
    <section className="py-28 px-6 bg-white">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-16">
          <p className="text-xs tracking-widest uppercase text-amber-600 mb-3" style={{ fontFamily: "'Inter', sans-serif" }}>FAQ</p>
          <h2 className="text-4xl md:text-5xl font-light text-stone-900" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
            Common <em className="not-italic font-semibold">Questions</em>
          </h2>
        </div>
        <div className="divide-y divide-stone-100">
          {faqs.map((faq, i) => (
            <div key={i} className="py-5">
              <button
                className="w-full flex items-center justify-between gap-4 text-left cursor-pointer group"
                onClick={() => setOpen(open === i ? null : i)}
              >
                <span className="text-stone-900 font-medium text-sm group-hover:text-amber-700 transition-colors" style={{ fontFamily: "'Inter', sans-serif" }}>{faq.q}</span>
                <span className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                  <i className={`text-stone-400 text-base transition-transform duration-300 ${open === i ? "ri-subtract-line" : "ri-add-line"}`}></i>
                </span>
              </button>
              {open === i && (
                <p className="mt-3 text-stone-500 text-sm leading-relaxed pr-10" style={{ fontFamily: "'Inter', sans-serif" }}>{faq.a}</p>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
